import React from 'react';
import UserAvatar from './UserAvatar';
import { userDisplayLabel } from '../utils/userDisplayLabel';

export function MessagingConversationListItem({ conv, selectedConvId, onSelect, title }) {
  const active = String(selectedConvId) === String(conv._id);
  const unread = conv.unread > 0;
  return (
    <div
      onClick={() => onSelect(conv._id)}
      className={`messaging-conv-item ${active ? 'messaging-conv-item--active' : ''} ${unread ? 'messaging-conv-item--unread' : ''}`}
      style={{ cursor: 'pointer' }}
    >
      <div className="messaging-conv-item__head">
        <UserAvatar photoUrl={conv.otherParty?.profilePhotoUrl} label={title} size={40} />
        <div className="messaging-conv-item__body">
          <div className="messaging-conv-item__name">{title}</div>
          <div className="messaging-conv-item__preview">{conv.lastMessage?.text}</div>
          {conv.requestRef && <div className="messaging-conv-item__meta">Request: {conv.requestRef.title}</div>}
          {conv.jobRef && <div className="messaging-conv-item__meta">Job: {conv.jobRef.title}</div>}
        </div>
      </div>
      {unread && <span className="badge badge-warning messaging-conv-item__badge">{conv.unread}</span>}
    </div>
  );
}

export function MessagingMessageRow({ msg, meUser, formatLocalDateTime }) {
  const label = msg.fromMe ? userDisplayLabel(meUser) : msg.sender?.name || '?';
  const photoUrl = msg.fromMe ? meUser?.profilePhotoUrl : msg.sender?.profilePhotoUrl;
  return (
    <div
      className={
        msg.fromMe ? 'messaging-bubble-wrap messaging-bubble-wrap--me' : 'messaging-bubble-wrap messaging-bubble-wrap--them'
      }
    >
      <div className="messaging-bubble-row">
        <UserAvatar photoUrl={photoUrl} label={label} size={32} className="messaging-msg-avatar" />
        <div className="messaging-bubble-stack">
          <div className={`messaging-bubble ${msg.fromMe ? 'messaging-bubble--me' : 'messaging-bubble--them'}`}>{msg.text}</div>
          <span className="messaging-time">{formatLocalDateTime(msg.at)}</span>
        </div>
      </div>
    </div>
  );
}
